/**
 * @generated SignedSource<<8c1ddf3f3c39d42c8d6049bc77bdc0bb>>
 * @relayHash 84b10c13ebafa3e202537480b5e519f2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/550.0.0-2026-03-10T14:52:08.510Z/zipCodeLookupQuery

import { ConcreteRequest } from 'relay-runtime';
export type zipCodeLookupQuery$variables = {
  country: string;
  zipCode: string;
};
export type zipCodeLookupQuery$data = {
  readonly viewer: {
    readonly zipCode: ReadonlyArray<{
      readonly city: string | null;
      readonly country: string | null;
      readonly state: string | null;
    } | null> | null;
  };
};
export type zipCodeLookupQuery = {
  response: zipCodeLookupQuery$data;
  variables: zipCodeLookupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "country"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zipCode"
},
v2 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "zipCode"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "zipCodeLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "zipCode",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "zipCodeLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "zipCode",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/550.0.0-2026-03-10T14:52:08.510Z/zipCodeLookupQuery",
    "metadata": {},
    "name": "zipCodeLookupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e8c10a44b9376bcc81c18823387740fc";

export default node;
